class Video {
    constructor() {
        this.$videos = $('.js-video');

        if (!this.$videos.length) return;

        this.addEventListeners();
    }

    addEventListeners() {
        this.$videos.on('click', function () {
            const $this = $(this);
            const $overlay = $this.find('.js-video-overlay');
            const $embed = $this.find('.js-video-embed');

            if (!$overlay.length || $embed.find('iframe').length) return;

            $embed.append(`
                <iframe width="auto"
                    height="auto"
                    src="${$embed[0].dataset.src}"
                    frameborder="0"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowfullscreen>
                </iframe>
            `);

            if ('ytTracker' in window) {
                window.ytTracker.init();
            }

            $overlay.fadeOut();
        });
    }
}

export default new Video();

